import { MINUTES_IN_HOUR } from '@repo/date-time';
export const calculateAverageHourlyPrice = (flatPrice, parkDuration) => {
    if (parkDuration <= 0) {
        return { amount: 0, currency: flatPrice.currency };
    }
    const hourlyRate = flatPrice.amount / (parkDuration / MINUTES_IN_HOUR);
    return {
        amount: hourlyRate,
        currency: flatPrice.currency,
    };
};
